import tenantUtils from '@utils';
import { NetworkService } from '../../../../services/networkService';
import { getTimeDateString } from '../../../../utility/date';
import { listingDetailMapper } from '../listings/listingsApis';

const iconMappings = {
  whatsapp: { icon: 'RiWhatsappFill', iconProps: { color: '#25D366', size: '12px' } },
  call: { icon: 'IoCall' },
  email: { icon: 'FaEnvelope' },
  manual: { icon: 'FaHandPointer' },
};
const leadInterestsMapper = (item) => {
  return {
    date: { value: item?.recorded_at, showTime: true, showPopover: false },
    listing_detail: { ...listingDetailMapper(item?.listing), interestId: item?.id },
    lead_source: {
      ...iconMappings?.[item?.source],
      sourceTitle: tenantUtils.getLocalisedString(item, 'source_title'),
      type: item?.source,
      content: tenantUtils.getLocalisedString(item, 'message_body'),
      date: item?.recorded_at,
      recording_uuid: item?.recording_url,
      callStatus: item?.call_status,
    },
  };
};

export const getLeadInterests = async (leadId, queryObj) => {
  const response = await NetworkService.get(`/api/lms/interests?q[lead_id_eq]=${leadId}&page=${queryObj?.page || 1}`);
  if (response?.error) {
    return response;
  } else {
    return {
      list: response?.data?.interests.map((item) => leadInterestsMapper(item)),
      pagination: tenantUtils.getPaginationObject(response?.data?.pagination),
    };
  }
};
